// Featured Collection Slick Slider 
$('.slick-slider--desktop').each(function() {
  var sliderTag = $(this);
  var column = sliderTag.data('column'),
      mobileColumn = sliderTag.data('mColumn');
  $(sliderTag).slick({
  dots: true,
  arrows: true,  
  infinite: true,
  slidesToShow: column,  
  centerMode: true,
  centerPadding: '40px',
  slidesToScroll: 2,
  prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="8" viewBox="0 0 25 8" fill="none"><path d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64644L3.82843 0.464464C4.02369 0.269202 4.34027 0.269202 4.53553 0.464464C4.7308 0.659727 4.7308 0.976309 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.73079 4.02369 7.73079 3.82843 7.53553L0.646446 4.35355ZM25 4.5L1 4.5L1 3.5L25 3.5L25 4.5Z" fill="#5F5A54"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="8" viewBox="0 0 25 8" fill="none"><path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64644L21.1716 0.464464C20.9763 0.269202 20.6597 0.269202 20.4645 0.464464C20.2692 0.659727 20.2692 0.976309 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.73079 20.9763 7.73079 21.1716 7.53553L24.3536 4.35355ZM4.37114e-08 4.5L24 4.5L24 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z" fill="#5F5A54"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3                
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: mobileColumn,
        arrows: false
      }
    }
  ]
});
})



// Testimonial Slider
$(document).ready(function() {  
  $('.testimonial_content_wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 800,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2000,
    asNavFor: '.testimonial_logo_wrapper',
    prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5012 23.3137L1.1875 12L12.5012 0.686291" stroke="black" stroke-width="1.33333"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.502698 23.3137L11.8164 12L0.502698 0.686291" stroke="black" stroke-width="1.33333"/></svg></button>'  
  });

  $('.testimonial_logo_wrapper').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    asNavFor: '.testimonial_content_wrapper',
    focusOnSelect: true      
  });
});


// Image Change On Variant Change
$(document).on('click','.variant-picker',function(){
    $(this).parents('.pro_grid_swatches').find('.collection_swatches').removeClass('active_color');
    $(this).parent('.collection_swatches').addClass('active_color');
    var getImg = $(this).data('image');
    var getOldImg = $(this).parents('.product-card-wrapper').find('.card__media .variantImg').attr('srcset',getImg);    
    var getVariantId = $(this).data('id');
    $(this).parents('.card__content').find('.Cart__btn').attr('data-variant-id',getVariantId)        
})

// // Product Add To Cart
function getVariantId() {
  setTimeout(function(){  
  const cartBtns = document.querySelectorAll('.Cart__btn');  
  cartBtns.forEach(function(cartBtn) {
    cartBtn.addEventListener('click', function(){   
      console.log("this",this)
      cartBtn.querySelector('.custom_add_icon').style.display = "none";
      cartBtn.querySelector('.spinner').style.display = "block";
      let varId = cartBtn.getAttribute('data-variant-id'),
          varQty = cartBtn.getAttribute('data-qty');
      console.log('clicked');
          addItemToCart(varId,varQty);  
    });
  });
  },2000)
}

getVariantId();

function addItemToCart(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {         
        console.log(this,'--this')
        window.location.href = '/cart'; 
      }
    });
}


//  Newslatter Popup
const closeBtn = document.querySelector('.close__btn');
const popup = document.getElementById('shopify-section-newslatter-popup');
document.addEventListener('DOMContentLoaded', function() {    
    if (!getCookie('popupShown')) {      
      setTimeout(function() {        
        if (popup) {
          popup.classList.add('active');
        }
      }, 5000);          
    }
  });
if (popup) {
popup.addEventListener('click',function() {
    setCookie('popupShown', 'true', 1);
})  
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}
if(closeBtn){
closeBtn.addEventListener('click',function() {
  popup.classList.remove('active');
})
  }



// Section Scroll Js
$(document).ready(function() {      
  $('.tab_title').click(function(event) {
    var HHeight = $('header').innerHeight();
    var tabHeight = $('.tabbing_section_wrapper .tab_wrapper').innerHeight();
    var THeight = HHeight + tabHeight;
    event.preventDefault();
    $('.tab_title').removeClass('active');
    $(this).addClass('active');  
    var title = $(this).data('sectiontitle');    
    $('html, body').animate({
      scrollTop: $(`#${title}`).offset().top - THeight
    }, 1000);
  });
});

var sections = document.querySelectorAll('[data-title]');
var nav = document.querySelector('.tabbing_section_wrapper');
var nav_height = nav?.offsetHeight + 100;

if (nav) {
    window.addEventListener('scroll', function () {
        var cur_pos = window.scrollY;       
        sections.forEach(function (section) {
            var top = section.offsetTop - nav_height;
            
            var bottom = top + section.offsetHeight;            
            if (cur_pos >= top && cur_pos <= bottom) {
                document.querySelectorAll('.tab_title').forEach(function (navItem) {
                    navItem.classList.remove('active');
                });
                sections.forEach(function (sectionItem) {
                    sectionItem.classList.remove('active');
                });

                section.classList.add('active');
                var store = section.getAttribute('data-title');
                var matchingNavItem = document.querySelector(`.tab_title[data-sectiontitle="${store}"]`);
                if (matchingNavItem) {
                    matchingNavItem.classList.add('active');
                }
            }
        });
    });
}



// Accordion Js
$(document).on('click',".accordion-title",function(){
    let $this = $(this);  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(500);
        $this.removeClass('active');
    } else {
        $this.parent().parent().find('.accordion-content').removeClass('show');
        $('.accordion-title').removeClass('active')
        $this.parent().parent().find('.accordion-content').slideUp(350);        
        $this.next().toggleClass('show');
        $this.addClass('active');
        $this.next().slideToggle(500);
    }
});

//  Multicolumn Slider
$('.multicolumn-list-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="8" viewBox="0 0 25 8" fill="none"><path d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64644L3.82843 0.464464C4.02369 0.269202 4.34027 0.269202 4.53553 0.464464C4.7308 0.659727 4.7308 0.976309 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.73079 4.02369 7.73079 3.82843 7.53553L0.646446 4.35355ZM25 4.5L1 4.5L1 3.5L25 3.5L25 4.5Z" fill="#5F5A54"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="8" viewBox="0 0 25 8" fill="none"><path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64644L21.1716 0.464464C20.9763 0.269202 20.6597 0.269202 20.4645 0.464464C20.2692 0.659727 20.2692 0.976309 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.73079 20.9763 7.73079 21.1716 7.53553L24.3536 4.35355ZM4.37114e-08 4.5L24 4.5L24 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z" fill="#5F5A54"/></svg></button>',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1                
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 374,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }  
  ]
});


// Menu Open On Hover
let items = document.querySelector(".header__inline-menu").querySelectorAll(".list-menu .mega-menu-details .header__menu-item");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.parentElement.setAttribute("open", true);
  });
  item.parentElement.addEventListener("mouseleave", () => {
    item.parentElement.removeAttribute("open");
    // document.querySelector(".mega-menu__list").style.display = "grid";    
  });
});

//  Announcement Bar slide js
$(function() {
  var quotes = $(".announcement-bar__items > li");
  var quoteIndex = -1;  
  function showNextQuote() {
    ++quoteIndex;
    quotes.eq(quoteIndex % quotes.length)
      .fadeIn(1000)
      .delay(3000)
      .fadeOut(1000, showNextQuote);
  }  
  showNextQuote();
});

// Shop Banner
$('body').click(function() {
    document.querySelectorAll('.dots_wrapper').forEach(function(e){
         e.classList.remove('active-bstl-dot');
    });   
});
$(document).on('click',".dots_wrapper",function(){
    if($(this).hasClass("active-bstl-dot")){
        $(this).removeClass("active-bstl-dot");        
    }else{
        $('.stl__dot--container-new').removeClass("active-bstl-dot");        
        $(this).addClass("active-bstl-dot");        
    }
});

$(document).on('mouseenter mouseleave', ".dots_wrapper", function(event) {        
    if (event.type === "mouseenter") {
       // $(this).siblings(".active-bstl-dot").removeClass("active-bstl-dot");
       //  $(this).toggleClass("active-bstl-dot");
      $(this).addClass("active-bstl-dot");
    } else if (event.type === "mouseleave" && !$(this).is(':hover')) {
        // console.log('out')
        $(this).removeClass("active-bstl-dot");
    }
});

// Related Product Heading
setTimeout(function(){
var productLength = $('.product-listing_main_ul .product-listing_main_li').length;
if(productLength == 0) {
    $('.recently_related_main').css("display","none");    
} else {
    $('.recently_related_main').css("display","block");
}
},200)

// Product Page Text Field

// old code

// $('.product_check_box ul li input[type="radio"]').change(function(){
//     console.log($(this).val())
//     if($(this).val() == 'yes'){
//         $('.product-personalizer').addClass("active");
//     } else {
//       $('.product-personalizer').removeClass("active");
//       $('.pplr_text').val('');
//     }
// })

// New Code

// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelector('.product_check_box').addEventListener('change', function(e) {
//     if (e.target.type === 'radio') {
//       console.log(e.target.value);

//       if (e.target.value === 'yes') {
//         document.querySelector('.product-personalizer')?.classList.add('active');
//       } else {
//         document.querySelector('.product-personalizer')?.classList.remove('active');
//         const pplrText = document.querySelector('.pplr_text');
//         if (pplrText) pplrText.value = '';
//       }
//     }
//   });
// });


// Gift Prodcut Date Validation
$(function(){
    var dtToday = new Date();
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    if(month < 10)
        month = '0' + month.toString();
    if(day < 10)
        day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;       
    $('.date_field').attr('min', maxDate);
});

//  Animation
document.addEventListener('DOMContentLoaded', function() {
      AOS.init();
});
